import { ContentCopy, Delete, PixOutlined } from "@mui/icons-material";
import React, { memo, useState } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const [isHovered, setIsHovered] = useState(false);

  const d = data || {};
  const porVariavel = String(d.origem || "gerar") === "variavel";
  const resumo = porVariavel
    ? `Código de ${d.codigoVar || "variável"}`
    : d.chave
    ? `Chave: ${d.chave}`
    : "Chave Pix não definida";

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        backgroundColor: "#ffffff",
        padding: "20px",
        borderRadius: "16px",
        minWidth: "250px",
        maxWidth: "250px",
        width: "250px",
        boxSizing: "border-box",
        position: "relative",
        fontFamily: "'Inter', sans-serif",
        border: "2px solid #e5e7eb",
        boxShadow: isHovered
          ? "0 12px 32px rgba(0,0,0,0.12)"
          : "0 4px 16px rgba(0,0,0,0.06)",
        transition: "all 0.2s cubic-bezier(0.4,0,0.2,1)",
        transform: isHovered ? "translateY(-2px)" : "translateY(0px)",
        pointerEvents: "auto",
        userSelect: "none",
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "linear-gradient(135deg, #22c55e, #15803d)",
          width: "16px",
          height: "16px",
          top: "24px",
          left: "-10px",
          cursor: "pointer",
          border: "3px solid #ffffff",
        }}
        isConnectable={isConnectable}
      />

      <div
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          display: "flex",
          gap: "4px",
          zIndex: 10,
          opacity: isHovered ? 1 : 0,
          transition: "opacity 0.2s",
        }}
      >
        <div
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          style={{
            width: "28px",
            height: "28px",
            cursor: "pointer",
            borderRadius: "8px",
            backgroundColor: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ContentCopy sx={{ width: "14px", height: "14px", color: "#6b7280" }} />
        </div>
        <div
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          style={{
            width: "28px",
            height: "28px",
            cursor: "pointer",
            borderRadius: "8px",
            backgroundColor: "#fee2e2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Delete sx={{ width: "14px", height: "14px", color: "#dc2626" }} />
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
        <div
          style={{
            width: "34px",
            height: "34px",
            borderRadius: "10px",
            background: "linear-gradient(135deg, #22c55e, #15803d)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "10px",
            flexShrink: 0,
          }}
        >
          <PixOutlined sx={{ color: "#fff", width: "18px", height: "18px" }} />
        </div>
        <div style={{ fontWeight: 700, fontSize: "15px", color: "#111827" }}>
          Pagamento Pix
        </div>
      </div>

      <div
        style={{
          fontSize: "12px",
          color: "#4b5563",
          background: "#f9fafb",
          borderRadius: "8px",
          padding: "8px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        title={resumo}
      >
        {resumo}
      </div>

      {!porVariavel && d.valor ? (
        <div style={{ marginTop: 6, fontSize: 11, color: "#15803d", fontWeight: 600 }}>
          Valor: {d.valor}
        </div>
      ) : null}
      {!porVariavel && !d.valor ? (
        <div style={{ marginTop: 6, fontSize: 11, color: "#6b7280" }}>
          Cliente digita o valor
        </div>
      ) : null}
      {d.enviarQr ? (
        <div style={{ marginTop: 4, fontSize: 11, color: "#6b7280" }}>
          + QR Code
        </div>
      ) : null}

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "linear-gradient(135deg, #22c55e, #15803d)",
          border: "2px solid #ffffff",
          width: "14px",
          height: "14px",
          right: "-7px",
          top: "50%",
          transform: "translateY(-50%)",
        }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
